import { TicketStatus } from '@/app/shared/enums/customer/ticket-status.enum';
import { Model } from '@/app/shared/models/model';
import { InteractionModel } from './interaction.model';

export class TicketModel extends Model {
  public Protocol!: string;
  public Subject!: string;
  public ContractId!: string;
  public PolicyId!: string;
  public Status!: TicketStatus;
  public Created!: Date;
  public Updated!: Date;
  public Start!: Date;
  public Finish!: Date;
  public User!: {
    Id: string;
    Name: string;
  };
  public Interactions!: InteractionModel[];
}
